import { useState } from 'react';
import { useCanvasStore } from '../../store/canvas-store';
import { genMsgId } from '../../store/comments';
import { runCommentTurn } from '../../agent/commentTurn';

/** Fixed-position popover for the open comment thread. */
export function CommentPopover() {
  const openId = useCanvasStore((s) => s.openCommentThreadId);
  const comments = useCanvasStore((s) => s.doc.comments) ?? [];
  const setOpen = useCanvasStore((s) => s.setOpenCommentThread);
  const dispatch = useCanvasStore((s) => s.dispatch);
  const [draft, setDraft] = useState('');

  const thread = comments.find((t) => t.id === openId);
  if (!thread) return null;

  const sendReply = () => {
    const text = draft.trim();
    if (!text) return;
    dispatch({ t: 'comment.reply', threadId: thread.id, message: { id: genMsgId(), author: 'user', text, ts: Date.now() } });
    setDraft('');
  };

  return (
    <div className="fixed bottom-4 right-4 z-[70] w-[300px] rounded-[8px] bg-[var(--color-surface)] shadow-[var(--shadow-2)] border border-[var(--color-border)] flex flex-col font-sans text-[13px]">
      <div className="flex items-center justify-between px-3 py-2 border-b border-[var(--color-border)]">
        <span className="text-[var(--color-text-muted)] font-mono text-[11px]">{thread.id}</span>
        <div className="flex items-center gap-2">
          <button className="text-[var(--color-text-muted)] hover:text-[var(--color-text)]"
            onClick={() => dispatch({ t: 'comment.resolve', threadId: thread.id, resolved: !thread.resolved })}>
            {thread.resolved ? 'Reopen' : 'Resolve'}
          </button>
          <button className="text-[var(--color-text-muted)] hover:text-[var(--color-text)]" onClick={() => setOpen(null)}>✕</button>
        </div>
      </div>
      <div className="max-h-[240px] overflow-y-auto px-3 py-2 flex flex-col gap-2">
        {thread.messages.map((m) => (
          <div key={m.id}>
            <div className="text-[var(--color-text-muted)] text-[11px]">{m.author}</div>
            <div className="text-[var(--color-text)] whitespace-pre-wrap">{m.text}</div>
          </div>
        ))}
      </div>
      <div className="px-3 py-2 border-t border-[var(--color-border)] flex flex-col gap-2">
        <textarea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendReply(); } }}
          placeholder="Reply…"
          className="resize-none rounded-[4px] bg-[var(--color-bg)] border border-[var(--color-border)] px-2 py-1 text-[13px] outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-accent)]"
          rows={2}
        />
        <div className="flex items-center justify-between">
          <button className="text-[var(--color-text-muted)] hover:text-[var(--color-text)]" onClick={sendReply}>Reply</button>
          <button
            className="text-[var(--color-accent)] hover:underline"
            onClick={() => { void runCommentTurn(thread.id); }}
          >Ask Viv</button>
        </div>
      </div>
    </div>
  );
}
